"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _FlamingoSwapDetailsHandler_calculateUsingAmountToReceive, _FlamingoSwapDetailsHandler_calculateUsingAmountToUse, _FlamingoSwapDetailsHandler_formatSwapDetails, _FlamingoSwapDetailsHandler_createTradeData, _FlamingoSwapDetailsHandler_calculateAmountToUse, _FlamingoSwapDetailsHandler_calculateAmountToReceive;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamingoSwapDetailsHandler = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const FlamingoSwapConstants_1 = require("../../../constants/FlamingoSwapConstants");
const FlamingoSwapHelper_1 = require("../../../helpers/FlamingoSwapHelper");
class FlamingoSwapDetailsHandler {
    static calculateSwapDetails({ amountToReceive, amountToUse, network, route, slippage, tokenToReceive, tokenToUse, }) {
        const overrodeTokenToUse = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToUse);
        const overrodeTokenToReceive = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideToken(network, tokenToReceive);
        const overrodeRoute = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideRoute(network, route);
        const slippageFormatted = new bignumber_js_1.default(slippage * 10).shiftedBy(-3);
        if (amountToReceive) {
            return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_calculateUsingAmountToReceive).call(this, {
                network,
                amountToReceive,
                overrodeRoute,
                overrodeTokenToUse,
                overrodeTokenToReceive,
                slippageFormatted,
            });
        }
        else if (amountToUse) {
            return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_calculateUsingAmountToUse).call(this, {
                network,
                amountToUse,
                overrodeRoute,
                overrodeTokenToUse,
                overrodeTokenToReceive,
                slippageFormatted,
            });
        }
        else {
            throw new Error('AmountToReceive or amountToUse are required, but both aren`t provided');
        }
    }
}
exports.FlamingoSwapDetailsHandler = FlamingoSwapDetailsHandler;
_a = FlamingoSwapDetailsHandler, _FlamingoSwapDetailsHandler_calculateUsingAmountToReceive = function _FlamingoSwapDetailsHandler_calculateUsingAmountToReceive({ network, amountToReceive, overrodeRoute, overrodeTokenToUse, overrodeTokenToReceive, slippageFormatted, }) {
    const amountToReceiveBn = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideAmountInput(network, amountToReceive, overrodeTokenToReceive);
    const amountToUse = __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_calculateAmountToUse).call(this, {
        amountToReceive,
        route: overrodeRoute,
    });
    const amountToUseBn = new bignumber_js_1.default(amountToUse);
    const maximumSelling = amountToUseBn
        .times(FlamingoSwapConstants_1.FlamingoSwapConstants.BN_1.plus(slippageFormatted))
        .dp(0)
        .shiftedBy(-overrodeTokenToUse.decimals)
        .toFixed();
    const amountToUseToDisplay = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideAmountToDisplay(network, amountToUse, overrodeTokenToUse);
    const { fee, price, priceImpact } = __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_createTradeData).call(this, {
        amountToReceive: amountToReceiveBn,
        amountToUse: amountToUseBn,
        route: overrodeRoute,
    });
    return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_formatSwapDetails).call(this, {
        amountToReceiveToDisplay: amountToReceive,
        amountToUseToDisplay,
        fee,
        price,
        priceImpact,
        overrodeTokenToUse,
        overrodeTokenToReceive,
        slippageFormatted,
        minimumReceived: null,
        maximumSelling,
    });
}, _FlamingoSwapDetailsHandler_calculateUsingAmountToUse = function _FlamingoSwapDetailsHandler_calculateUsingAmountToUse({ network, amountToUse, overrodeRoute, overrodeTokenToUse, overrodeTokenToReceive, slippageFormatted, }) {
    const amountToUseBn = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideAmountInput(network, amountToUse, overrodeTokenToUse);
    const amountToReceive = __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_calculateAmountToReceive).call(this, {
        amountToUse,
        route: overrodeRoute,
    });
    const amountToReceiveBn = new bignumber_js_1.default(amountToReceive);
    const minimumReceived = amountToReceiveBn
        .times(FlamingoSwapConstants_1.FlamingoSwapConstants.BN_1.minus(slippageFormatted))
        .dp(0)
        .shiftedBy(-overrodeTokenToReceive.decimals)
        .toFixed();
    const amountToReceiveToDisplay = FlamingoSwapHelper_1.FlamingoSwapHelper.overrideAmountToDisplay(network, amountToReceiveBn.toString(), overrodeTokenToReceive);
    const { fee, price, priceImpact } = __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_createTradeData).call(this, {
        amountToReceive: amountToReceiveBn,
        amountToUse: amountToUseBn,
        route: overrodeRoute,
    });
    return __classPrivateFieldGet(this, _a, "m", _FlamingoSwapDetailsHandler_formatSwapDetails).call(this, {
        amountToReceiveToDisplay,
        amountToUseToDisplay: amountToUse,
        fee,
        price,
        priceImpact,
        overrodeTokenToUse,
        overrodeTokenToReceive,
        slippageFormatted,
        minimumReceived,
        maximumSelling: null,
    });
}, _FlamingoSwapDetailsHandler_formatSwapDetails = function _FlamingoSwapDetailsHandler_formatSwapDetails({ amountToReceiveToDisplay, amountToUseToDisplay, fee, price, priceImpact, overrodeTokenToUse, overrodeTokenToReceive, minimumReceived, maximumSelling, }) {
    const priceInverse = FlamingoSwapConstants_1.FlamingoSwapConstants.BN_1.div(price);
    const diffDecimals = overrodeTokenToUse.decimals - overrodeTokenToReceive.decimals;
    return {
        amountToReceiveToDisplay,
        amountToUseToDisplay,
        liquidityProviderFee: fee.shiftedBy(-8).plus(FlamingoSwapConstants_1.FlamingoSwapConstants.BN_0).toFixed(4),
        priceImpact: isFinite(Number(priceImpact)) ? priceImpact.shiftedBy(2).toFixed(4) : null,
        priceInverse: isFinite(Number(priceInverse)) ? priceInverse.multipliedBy(Math.pow(10, diffDecimals)).toFixed() : null,
        minimumReceived,
        maximumSelling,
    };
}, _FlamingoSwapDetailsHandler_createTradeData = function _FlamingoSwapDetailsHandler_createTradeData({ amountToReceive, amountToUse, route }) {
    const fee = amountToUse.minus(route.reduce(acc => acc.times(FlamingoSwapConstants_1.FlamingoSwapConstants.BN_1.minus(FlamingoSwapConstants_1.FlamingoSwapConstants.FEE_RATE)), amountToUse));
    const price = amountToUse.div(amountToReceive);
    const midPrice = route.reduce((acc, item) => acc.times(item.reserveTokenToUse).div(item.reserveTokenToReceive), FlamingoSwapConstants_1.FlamingoSwapConstants.BN_1);
    const priceImpact = price.minus(midPrice).div(price).minus(fee.div(amountToUse));
    return {
        fee,
        price,
        priceImpact,
        midPrice,
    };
}, _FlamingoSwapDetailsHandler_calculateAmountToUse = function _FlamingoSwapDetailsHandler_calculateAmountToUse({ amountToReceive, route }) {
    let amountToUse = '';
    let tempAmountToReceive = amountToReceive;
    route
        .reverse()
        .map(({ tokenToUse: tradeTokenToUse, tokenToReceive: tradeTokenToReceive, reserveTokenToUse, reserveTokenToReceive, }, index) => {
        if (amountToUse) {
            tempAmountToReceive = amountToUse;
        }
        const reserveTokenToUseBn = new bignumber_js_1.default(reserveTokenToUse);
        const reserveTokenToReceiveBn = new bignumber_js_1.default(reserveTokenToReceive);
        const tempAmountToReceiveBn = new bignumber_js_1.default(tempAmountToReceive).shiftedBy(tradeTokenToReceive.decimals);
        amountToUse = reserveTokenToUseBn
            .times(tempAmountToReceiveBn)
            .times(1000)
            .idiv(reserveTokenToReceiveBn.minus(tempAmountToReceiveBn).times(997))
            .plus(1)
            .toFixed();
        if (route.length > 1) {
            amountToUse = new bignumber_js_1.default(amountToUse).shiftedBy(-tradeTokenToUse.decimals).toFixed();
            if (index === route.length - 1) {
                amountToUse = new bignumber_js_1.default(amountToUse).shiftedBy(tradeTokenToUse.decimals).toFixed();
            }
        }
    });
    return amountToUse;
}, _FlamingoSwapDetailsHandler_calculateAmountToReceive = function _FlamingoSwapDetailsHandler_calculateAmountToReceive({ amountToUse, route }) {
    let amountToReceive = '';
    let tempAmountToUse = amountToUse;
    route.map(({ tokenToUse: tradeTokenToUse, tokenToReceive: tradeTokenToReceive, reserveTokenToUse, reserveTokenToReceive }, index) => {
        if (amountToReceive) {
            tempAmountToUse = amountToReceive;
        }
        const reserveTokenToUseBn = new bignumber_js_1.default(reserveTokenToUse);
        const tempAmountToUseWithFee = new bignumber_js_1.default(tempAmountToUse).times(997).shiftedBy(tradeTokenToUse.decimals);
        amountToReceive = tempAmountToUseWithFee
            .times(reserveTokenToReceive)
            .idiv(reserveTokenToUseBn.times(1000).plus(tempAmountToUseWithFee))
            .toFixed();
        if (route.length > 1) {
            amountToReceive = new bignumber_js_1.default(amountToReceive).shiftedBy(-tradeTokenToReceive.decimals).toFixed();
            if (index === route.length - 1) {
                amountToReceive = new bignumber_js_1.default(amountToReceive).shiftedBy(tradeTokenToReceive.decimals).toFixed();
            }
        }
    });
    return amountToReceive;
};
